export default "__VITE_ASSET__7abc3068__"